export default __webpack_public_path__ + "static/media/5d5a44ecbb4d958d8d61e02582ee8db3.8c0417b8.svg";